import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import GridPane from './_grid-pane.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'SportGroupsListSkeleton',
  values: {
    topSportGroups: {
      show: true,
      numberOfSportGroups: 3,
    },
    allSportGroups: {
      show: true,
      numberOfRegions: 2,
      numberOfSportGroups: 3,
    },
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '0',
          _mobile_padding: '0 8px',
          flexDirection: 'column',
        },
      },
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          height: '40px',
          alignItems: 'center',
          padding: '16px 8px 0',
        },
      },
    },
    headerText: {
      configSet: Text,
      configValues: {},
    },
    leaguesContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    listContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '12px 8px',
          flexDirection: 'row',
          _mobile_flexDirection: 'column',
        },
      },
    },
    sportGroupsGridColumns: 2,
    _mobile_sportGroupsGridColumns: 1,
    sportGroupsGrid: {
      configSet: GridPane,
      configValues: {
        defaultColumnSize: '1fr',
      },
    },
    listGroupContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '20px',
        style: {
          flexDirection: 'column',
          flexBasis: '50%',
        },
      },
    },
    regionContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexGrow: 0,
          alignItems: 'center',
        },
      },
    },
    iconPlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '16px',
          height: '16px',
        },
      },
    },
    leaguePlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '200px',
          _mobile_width: '168px',
          height: '16px',
        },
      },
    },
    regionPlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '120px',
          height: '16px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
